"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("./Icon.style"));
var _excluded = ["className", "onClick", "icon", "size", "id", "disabled", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Icon = function Icon(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    icon = _ref.icon,
    size = _ref.size,
    id = _ref.id,
    disabled = _ref.disabled,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var properties = typeof onClick === 'function' && !disabled ? {
    onClick: onClick,
    onKeyDown: onClick,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    role: 'button',
    tabIndex: '0'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    className: "icon-".concat(icon, " ").concat(className),
    size: size,
    id: id,
    disabled: disabled
  }, properties, otherProps));
};
Icon.defaultProps = {
  className: '',
  icon: '',
  size: 12,
  id: '',
  onClick: null,
  onTouchStart: null,
  onTouchEnd: null,
  onMouseDown: null,
  onMouseUp: null,
  disabled: false
};
Icon.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  size: _propTypes["default"].number,
  id: _propTypes["default"].string,
  onTouchStart: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Icon);